<script lang="ts">
import { defineComponent, watch } from 'vue';
import loginFormOverlayService from '@/project/modals/overlays/LoginFormOverlay.service';
import authService from '@/core/auth/auth.service';
import serverContextService from '@/core/serverContext.service';
import { UrlQueryKey } from '@/core/urlQueryKey';
import { useRoute } from 'vue-router';
import consentOverlayService from '@/project/modals/overlays/ConsentOverlay.service';

export default defineComponent({
    setup(props, { slots }) {
        const route = useRoute();
        function checkForPasswordReset() {
            const params = new URLSearchParams(location.search);
            if (params.has(UrlQueryKey.ResetPassword)) {
                loginFormOverlayService.show('reset-pw', undefined, {
                    singleton: true,
                    closeOnRouteChange: false,
                    showCloseButton: false,
                    disableUserClose: true
                });
            }
        }

        function checkForPasswordForgot(allowUserInteraction = false) {
            const params = new URLSearchParams(location.search);
            if (params.has(UrlQueryKey.ForgotPassword)) {
                loginFormOverlayService.show('forgot-pw', undefined, {
                    singleton: true,
                    closeOnRouteChange: allowUserInteraction,
                    showCloseButton: true,
                    disableUserClose: false
                });
            }
        }

        function checkForPasswordExpired() {
            const params = new URLSearchParams(location.search);
            if (params.has(UrlQueryKey.ExpiredPassword)) {
                loginFormOverlayService.show('expired-pw', undefined, {
                    singleton: true,
                    closeOnRouteChange: false,
                    showCloseButton: true,
                    disableUserClose: false
                });
            }
        }

        function checkForLoginDialog() {
            const params = new URLSearchParams(location.search);
            if (params.has(UrlQueryKey.ShowLoginDialog) && !authService.isLoggedIn()) {
                loginFormOverlayService.show('login', undefined, {
                    singleton: true,
                    closeOnRouteChange: true,
                    showCloseButton: true,
                    disableUserClose: false
                });
            }
        }

        function checkForOciSession() {
            const params = new URLSearchParams(location.search);
            if (params.has(UrlQueryKey.PunchOutSession) && serverContextService.punchOutJwtToken) {
                authService.setToken(serverContextService.punchOutJwtToken);
            }
        }

        function checkForTermsAndConditionsRequired() {
            const params = new URLSearchParams(location.search);
            if (params.has(UrlQueryKey.ShowTermsAndConditionsOverlay) && authService.isLoggedIn() && serverContextService.settings?.dataProcessingAgreementPage) {
                setTimeout(() => {
                    consentOverlayService.show(serverContextService.settings.dataProcessingAgreementPage);
                },200);
            }
        }

        checkForPasswordReset();
        checkForPasswordForgot();
        checkForPasswordExpired();
        checkForOciSession();
        checkForTermsAndConditionsRequired();
        setTimeout(() => {
            // Needs timeout to let the page load
            checkForLoginDialog();
        }, 200);

        watch(() => route.query, () => {
            checkForPasswordForgot(true);
        });

        return () => {
            return slots.default?.();
        };
    }
});
</script>
